import client from "../axios"
import { DELETE_STORECOUNSEL, GET_STORECOUNSEL_DETAIL, POST_STORECOUNSEL, PUT_STORECOUNSEL, POST_DELETE_STORECOUNSEL } from "./endpoint"

// 가맹상담 등록
export const postStoreCounselAPI = (data) => {
  return client.post(POST_STORECOUNSEL, data)
}

// 가맹상담 상세
export const getStoreCounselAPI = (idx) => {
  return client.get(GET_STORECOUNSEL_DETAIL.replace(':idx', idx))
}

// 가맹상담 삭제
export const deleteStoreCounselAPI = (idx) => {
  return client.delete(DELETE_STORECOUNSEL.replace(':idx', idx))
}
// 가맹상담 삭제
export const postDeleteStoreCounselAPI = (arr) => {
  return client.post(POST_DELETE_STORECOUNSEL,arr)
}

// 가맹상담 수정
export const putStoreCounselAPI = (idx, data) => {
  return client.put(PUT_STORECOUNSEL.replace(':idx', idx), data)
}